"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentPartneredHotspotDto = exports.PartneredHotspotDto = exports.AdminPartneredHotspotDto = exports.AdminPartneredHotspotStatsDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const AdminVenueEvent_dto_1 = require("./AdminVenueEvent.dto");
const VenueSpecial_dto_1 = require("./VenueSpecial.dto");
const Venue_dto_1 = require("./Venue.dto");
/** Funnel for one partnered hotspot: modal opens → CTA → RSVP / tickets attributed to the hotspot. */
class AdminPartneredHotspotStatsDto {}
exports.AdminPartneredHotspotStatsDto = AdminPartneredHotspotStatsDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Automatic modal opens on launch (every occurrence).'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "modalShown", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Unique users the modal auto-opened for.'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "modalShownUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Taps on the collapsed card (every occurrence).'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "cardTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "cardTapUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Taps on the CTA inside the modal (every occurrence).'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "ctaTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "ctaUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Current RSVPs to the event with source = hotspot.'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "hotspotRsvps", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'All current RSVPs to the event, any source.'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "totalRsvps", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: '"Get tickets" taps with source = hotspot.'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "hotspotGetTicketsTaps", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Held tickets (pending / paid) with source = hotspot.'
}), __metadata("design:type", Number)], AdminPartneredHotspotStatsDto.prototype, "hotspotTickets", void 0);
class AdminPartneredHotspotDto {}
exports.AdminPartneredHotspotDto = AdminPartneredHotspotDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminPartneredHotspotDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventSummaryDto
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventSummaryDto)], AdminPartneredHotspotDto.prototype, "event", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEvent_dto_1.AdminVenueEventVenueDto,
  description: 'Venue hosting the event.'
}), __metadata("design:type", AdminVenueEvent_dto_1.AdminVenueEventVenueDto)], AdminPartneredHotspotDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: "The event's own start date, for reference."
}), __metadata("design:type", Object)], AdminPartneredHotspotDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: "The event's own end date, for reference."
}), __metadata("design:type", Object)], AdminPartneredHotspotDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether tickets for the event can be purchased in the app.'
}), __metadata("design:type", Boolean)], AdminPartneredHotspotDto.prototype, "eventIsTicketed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Event ticket price in cents (USD).'
}), __metadata("design:type", Object)], AdminPartneredHotspotDto.prototype, "eventTicketPriceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Start of the partnership window (inclusive).'
}), __metadata("design:type", String)], AdminPartneredHotspotDto.prototype, "startsAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'End of the partnership window (exclusive).'
}), __metadata("design:type", String)], AdminPartneredHotspotDto.prototype, "endsAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminPartneredHotspotDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminPartneredHotspotStatsDto
}), __metadata("design:type", AdminPartneredHotspotStatsDto)], AdminPartneredHotspotDto.prototype, "stats", void 0);
class PartneredHotspotDto {}
exports.PartneredHotspotDto = PartneredHotspotDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PartneredHotspotDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Start of the partnership window (inclusive).'
}), __metadata("design:type", String)], PartneredHotspotDto.prototype, "startsAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'End of the partnership window (exclusive).'
}), __metadata("design:type", String)], PartneredHotspotDto.prototype, "endsAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: Venue_dto_1.VenueDto,
  description: 'The venue hosting the partnered event.'
}), __metadata("design:type", Venue_dto_1.VenueDto)], PartneredHotspotDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueSpecial_dto_1.VenueSpecialDto,
  description: "The partnered event, with the current user's RSVP state."
}), __metadata("design:type", VenueSpecial_dto_1.VenueSpecialDto)], PartneredHotspotDto.prototype, "event", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: "When the current user was first shown this hotspot's highlight modal; null if never (the app auto-opens it once)."
}), __metadata("design:type", Object)], PartneredHotspotDto.prototype, "seenAt", void 0);
class CurrentPartneredHotspotDto {}
exports.CurrentPartneredHotspotDto = CurrentPartneredHotspotDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: PartneredHotspotDto,
  nullable: true,
  description: 'Null when no partnered hotspot is active right now.'
}), __metadata("design:type", Object)], CurrentPartneredHotspotDto.prototype, "partneredHotspot", void 0);
//# sourceMappingURL=PartneredHotspot.dto.js.map